// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.5
// source: roboverse_platform_protos/statekeeping/Reported/Localization.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { PoseStamped } from "../Common/Geometry";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Reported";

export interface Localization {
  mapId: string;
  robotPose: PoseStamped | undefined;
  isMapRecording: boolean;
  currentFiducials: number[];
  gpsPosition: Localization_GPSLocation | undefined;
}

export interface Localization_GPSLocation {
  timeStampUTC:
    | Date
    | undefined;
  /** [deg] Latitude (WGS84, EGM96 ellipsoid) */
  latitude: number;
  /** [deg] Longitude (WGS84, EGM96 ellipsoid) */
  longitude: number;
  /** [mm] Altitude (MeanSeaLevel). Positive for up. Note that virtually all GPS modules provide the MeanSeaLevel altitude in addition to the WorldGeodeticSystem1984 altitude. */
  altitude: number;
}

function createBaseLocalization(): Localization {
  return { mapId: "", robotPose: undefined, isMapRecording: false, currentFiducials: [], gpsPosition: undefined };
}

export const Localization: MessageFns<Localization> = {
  encode(message: Localization, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mapId !== "") {
      writer.uint32(10).string(message.mapId);
    }
    if (message.robotPose !== undefined) {
      PoseStamped.encode(message.robotPose, writer.uint32(18).fork()).join();
    }
    if (message.isMapRecording !== false) {
      writer.uint32(24).bool(message.isMapRecording);
    }
    writer.uint32(34).fork();
    for (const v of message.currentFiducials) {
      writer.int64(v);
    }
    writer.join();
    if (message.gpsPosition !== undefined) {
      Localization_GPSLocation.encode(message.gpsPosition, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Localization {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocalization();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mapId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.robotPose = PoseStamped.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isMapRecording = reader.bool();
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.currentFiducials.push(longToNumber(reader.int64()));

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.currentFiducials.push(longToNumber(reader.int64()));
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.gpsPosition = Localization_GPSLocation.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Localization {
    return {
      mapId: isSet(object.mapId) ? globalThis.String(object.mapId) : "",
      robotPose: isSet(object.robotPose) ? PoseStamped.fromJSON(object.robotPose) : undefined,
      isMapRecording: isSet(object.isMapRecording) ? globalThis.Boolean(object.isMapRecording) : false,
      currentFiducials: globalThis.Array.isArray(object?.currentFiducials)
        ? object.currentFiducials.map((e: any) => globalThis.Number(e))
        : [],
      gpsPosition: isSet(object.gpsPosition) ? Localization_GPSLocation.fromJSON(object.gpsPosition) : undefined,
    };
  },

  toJSON(message: Localization): unknown {
    const obj: any = {};
    if (message.mapId !== "") {
      obj.mapId = message.mapId;
    }
    if (message.robotPose !== undefined) {
      obj.robotPose = PoseStamped.toJSON(message.robotPose);
    }
    if (message.isMapRecording !== false) {
      obj.isMapRecording = message.isMapRecording;
    }
    if (message.currentFiducials?.length) {
      obj.currentFiducials = message.currentFiducials.map((e) => Math.round(e));
    }
    if (message.gpsPosition !== undefined) {
      obj.gpsPosition = Localization_GPSLocation.toJSON(message.gpsPosition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Localization>, I>>(base?: I): Localization {
    return Localization.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Localization>, I>>(object: I): Localization {
    const message = createBaseLocalization();
    message.mapId = object.mapId ?? "";
    message.robotPose = (object.robotPose !== undefined && object.robotPose !== null)
      ? PoseStamped.fromPartial(object.robotPose)
      : undefined;
    message.isMapRecording = object.isMapRecording ?? false;
    message.currentFiducials = object.currentFiducials?.map((e) => e) || [];
    message.gpsPosition = (object.gpsPosition !== undefined && object.gpsPosition !== null)
      ? Localization_GPSLocation.fromPartial(object.gpsPosition)
      : undefined;
    return message;
  },
};

function createBaseLocalization_GPSLocation(): Localization_GPSLocation {
  return { timeStampUTC: undefined, latitude: 0, longitude: 0, altitude: 0 };
}

export const Localization_GPSLocation: MessageFns<Localization_GPSLocation> = {
  encode(message: Localization_GPSLocation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timeStampUTC !== undefined) {
      Timestamp.encode(toTimestamp(message.timeStampUTC), writer.uint32(10).fork()).join();
    }
    if (message.latitude !== 0) {
      writer.uint32(17).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(25).double(message.longitude);
    }
    if (message.altitude !== 0) {
      writer.uint32(33).double(message.altitude);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Localization_GPSLocation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocalization_GPSLocation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.timeStampUTC = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.altitude = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Localization_GPSLocation {
    return {
      timeStampUTC: isSet(object.timeStampUTC) ? fromJsonTimestamp(object.timeStampUTC) : undefined,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : 0,
    };
  },

  toJSON(message: Localization_GPSLocation): unknown {
    const obj: any = {};
    if (message.timeStampUTC !== undefined) {
      obj.timeStampUTC = message.timeStampUTC.toISOString();
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.altitude !== 0) {
      obj.altitude = message.altitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Localization_GPSLocation>, I>>(base?: I): Localization_GPSLocation {
    return Localization_GPSLocation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Localization_GPSLocation>, I>>(object: I): Localization_GPSLocation {
    const message = createBaseLocalization_GPSLocation();
    message.timeStampUTC = object.timeStampUTC ?? undefined;
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.altitude = object.altitude ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
